import React from "react";
import { valueConverter } from "../../util-functions/util-funtions";
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  YAxis,
  LabelList,
} from "recharts";
const COLORS = ['#023e7d', '#e57d2f', '#e1b56c', '#0353a4', '#63993d']


const CustomizedLabel = (props) => {
  const { x, y, stroke, value, width } = props;
  try {
    return (
      <g
        style={{
          writingMode: "vertical-rl",
          transform: "rotate(-180deg)",
          transformOrigin: `${x + width / 2}px ${y - 10}px`,
        }}
      >
        <text
          x={x + width / 2}
          y={y}
          dy={0}
          fill={stroke}
          fontSize={12}
          textAnchor="middle"
        >
          {value?.toFixed(2)}
        </text>
      </g>
    );
  } catch (error) {
    console.log(error)
    return ''
  }
};

const DTTSChart = (props) => {
  const renderTooltip = (e) => {
    try {
      return (
        <div className="dtts-tooltip">
          <span>{e.label}</span>
          <span className="dtts-tooltip-values">
            {e.payload &&
              e.payload.map((item, ind) => (
                <span key={ind} style={{ color: e.payload[ind].color }}>
                  {e.payload[ind].dataKey} : {item.value?.toFixed(2)}
                </span>
              ))}
          </span>
        </div>
      );
    } catch (error) {
      console.log(error)
      return ''
    }
  };

  const renderLegend = (props) => {
    try {
      if (props.payload) {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {
              props.payload.map((item, ind) => (
                <span
                  key={ind}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "16px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      backgroundColor: item.color,
                      marginRight: "8px",
                    }}
                  ></span>
                  <span>{item.dataKey}</span>
                </span>
              ))
            }
          </div>
        )
      }
    } catch (error) {
      console.log(error)
      return ''
    }
  };

  return (
    <>
      <ResponsiveContainer height="100%" width="100%">
        <BarChart
          width={550}
          height={180}
          data={props?.data}
          margin={{
            top: 5,
            right: 30,
            left: 0,
            bottom: 5,
          }}
          barCategoryGap={8}
        >
          <YAxis
            axisLine={{ stroke: "#e6e6e7" }}
            style={{ fontSize: "12px" }}
            tickLine={false}
            padding={{ top: 35 }}
            type="number"
            tickFormatter={(tick) => {
              return valueConverter(tick) + "%";
            }}
          />
          <XAxis
            axisLine={{ stroke: "#e6e6e7" }}
            dataKey={props.ObjKey}
            style={{ fontSize: "12px" }}
            tickLine={false}
          />
          <Tooltip content={(e) => renderTooltip(e)} />
          <Legend content={renderLegend} />

          {
            props.data?.length && Object.keys(props.data[0])
              .filter((item, ind) => (Object.keys(props.data[0]).length - 1) !== ind)
              .map((elm, indx) => (
                <Bar dataKey={elm} fill={COLORS[indx]} key={`${COLORS[indx]}${indx}`}>
                  <LabelList
                    content={
                      <CustomizedLabel myProps={props.data ? props.data : []} />
                    }
                    position="insideTop"
                  />
                </Bar>
              ))
          }
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default DTTSChart;
